import { type DecisioningFactorId, Dtos, type SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { observedValuesQueryKey } from "../decisioning.keys";

type FactorValue = Dtos.Decisioning.FactorValue;

const parseObservedValues = (data: unknown): ReadonlyMap<DecisioningFactorId, FactorValue> =>
	new Map(
		Dtos.Decisioning.ProCon.ObservedValues.Response.schema
			.parse(data)
			.map(({ factorId, value }) => [factorId, value]),
	);

/** The value a new pro/con on each factor would read from account data, keyed by factor id. */
export const useFetchObservedValues = (accountId: SuretyAccountId, enabled = true) => {
	const { get } = useRequest();

	const query = useQuery({
		queryKey: observedValuesQueryKey(accountId),
		meta: { suppressErrorModal: true },
		enabled,
		queryFn: async () =>
			parseObservedValues(
				await get<unknown>(`/v2/admin/surety/accounts/${accountId}/pro-cons/observed-values`),
			),
	});

	return {
		observedValues: query.data,
		observedValuesIsLoading: query.isLoading,
		observedValuesError: query.error,
	};
};
